var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 492,
    viewBox: "0 0 492 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2359_16701)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2359_16701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 492,
    height: 492
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492 0H0V492H492V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2359_16701)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2359_16701",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 492,
    height: 492
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.05176e-05H492V492H0V3.05176e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2359_16701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.781 248.883V415.125C472.781 446.968 446.968 472.781 415.125 472.781H76.875C45.0324 472.781 19.2188 446.968 19.2188 415.125V76.875C19.2188 45.0324 45.0324 19.2188 76.875 19.2188H244.078",
    stroke: "black",
    strokeWidth: 36,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.859 145.102L222.938 270.023",
    stroke: "black",
    strokeWidth: 36,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.959 217.363C389.812 213.064 410.145 201.327 429.858 181.658L431.859 179.346L434.174 177.341C459.415 152.063 472.78 125.46 472.78 100.441C472.78 80.5392 464.377 62.0566 447.806 45.5092C444.572 42.2805 441.19 39.3064 437.754 36.6715L435.886 35.2407L435.706 34.9879C422.358 25.1595 407.84 20.1799 392.517 20.1799C367.516 20.1799 340.932 33.5273 315.617 58.7884L313.616 61.1014L311.298 63.1069C286.059 88.3843 272.693 114.988 272.693 140.004C272.693 150.429 275.27 160.681 279.839 170.247C279.839 170.247 290.161 186.126 295.719 191.684",
    stroke: "black",
    strokeWidth: 36,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.914 197.127C179.634 201.846 160.303 214.146 140.938 233.467L138.936 235.78L136.621 237.785C111.38 263.062 98.0156 289.665 98.0156 314.685C98.0156 334.587 106.418 353.069 122.989 369.617C126.223 372.846 129.605 375.819 133.042 378.454L134.909 379.885L135.09 380.138C148.437 389.966 162.956 394.945 178.278 394.945C203.28 394.945 229.863 381.599 255.179 356.338L257.18 354.024L259.497 352.019C284.736 326.742 298.102 300.137 298.102 275.121C298.102 264.696 295.526 254.446 290.956 244.881C290.956 244.881 282.223 227.414 275.871 221.061",
    stroke: "black",
    strokeWidth: 36,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2359_16701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 492,
    height: 492,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.da05ba51eb9f51128afd534ff4c68d04.svg";
export { ForwardRef as ReactComponent };